import { DropdownOptionModel } from "./Dropdown.model";
import { TFunction } from "i18next";

export const toDropdownOptions = (options: string[]): DropdownOptionModel[] => {
  return options.map(option => {
    return { label: option, value: option };
  });
};

export const toDropdownTranslateOptions = (
  options: string[],
  transKey: string,
  transFunc: TFunction
): DropdownOptionModel[] => {
  return options.map(option => {
    return { label: transFunc(`${transKey}.${option}`), value: option };
  });
};
